var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1585,
    height: 2467,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-143 -746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.591 835.768C262.728 803.216 290.037 777.749 322.589 778.886L1658.94 825.552C1691.49 826.689 1716.96 853.999 1715.82 886.551L1638.32 3105.83C1637.19 3138.38 1609.88 3163.85 1577.32 3162.71L240.974 3116.04C208.422 3114.91 182.955 3087.6 184.092 3055.05Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#3F3F3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 870.471C208.5 837.902 234.902 811.5 267.471 811.5L1604.52 811.5C1637.09 811.5 1663.49 837.902 1663.49 870.471L1663.49 3091.53C1663.49 3124.1 1637.09 3150.5 1604.52 3150.5L267.471 3150.5C234.902 3150.5 208.5 3124.1 208.5 3091.53Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#F7534A",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 939.79C250.5 919.748 266.748 903.5 286.791 903.5L1585.21 903.5C1605.25 903.5 1621.5 919.748 1621.5 939.79L1621.5 3075.21C1621.5 3095.25 1605.25 3111.5 1585.21 3111.5L286.791 3111.5C266.748 3111.5 250.5 3095.25 250.5 3075.21Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 857C292 842.64 303.641 831 318 831 332.359 831 344 842.64 344 857 344 871.359 332.359 883 318 883 303.641 883 292 871.359 292 857Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#45B382",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 857C387 842.64 398.641 831 413 831 427.359 831 439 842.64 439 857 439 871.359 427.359 883 413 883 398.641 883 387 871.359 387 857Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#FFD600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 855C481 840.641 492.641 829 507 829 521.359 829 533 840.641 533 855 533 869.359 521.359 881 507 881 492.641 881 481 869.359 481 855Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#FBFFFA",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDefault);
export default __webpack_public_path__ + "static/media/box_default.e4b39c18fa19c26d612cd844f4924756.svg";
export { ForwardRef as ReactComponent };